import clsx from 'clsx';

export const Telegram = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.24157 6.90067C6.10819 4.64981 9.34798 3.15417 10.9748 2.42856C15.6051 0.370208 16.5784 0.0148083 17.2041 0C17.3432 0 17.6491 0.0296168 17.8576 0.207316C18.0245 0.355399 18.0662 0.547908 18.094 0.695991C18.1218 0.844074 18.1496 1.15505 18.1218 1.39198C17.8715 4.20556 16.787 11.0322 16.2308 14.1715C15.9944 15.5043 15.5355 15.9485 15.0906 15.993C14.1173 16.0818 13.3803 15.3118 12.4487 14.6602C10.9748 13.6384 10.1544 13.0017 8.72227 11.9947C7.06762 10.8397 8.13827 10.2029 9.08379 9.16634C9.33407 8.89979 13.6028 4.75347 13.6862 4.38326C13.7001 4.33883 13.7001 4.16113 13.6028 4.07228C13.5055 3.98343 13.3664 4.01305 13.2552 4.04267C13.1022 4.07228 10.7663 5.73081 6.21943 9.00345C5.55201 9.49212 4.95411 9.72905 4.41183 9.71425C3.81393 9.69944 2.67375 9.35885 1.81166 9.06268C0.768808 8.70728 -0.0654719 8.51477 0.00405142 7.89282C0.0457654 7.56704 0.462905 7.24126 1.24157 6.90067Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const TelegramTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M13.4545 19.9189L24.2727 9.35135L9.63636 18.0541L2 15.5676L30 5L24.2727 28L17.2727 23.027L12.8182 26.7568L13.4545 19.9189Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Home = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="home-6-fill">
        <path
          id="Vector"
          d="M21.8 20.0003C21.8 20.2655 21.6947 20.5198 21.5072 20.7074C21.3196 20.8949 21.0653 21.0003 20.8 21.0003H4.80005C4.53483 21.0003 4.28048 20.8949 4.09294 20.7074C3.90541 20.5198 3.80005 20.2655 3.80005 20.0003V9.49027C3.79994 9.33788 3.83467 9.18749 3.90156 9.05057C3.96846 8.91365 4.06577 8.79384 4.18605 8.70027L12.186 2.47827C12.3616 2.34172 12.5776 2.26758 12.8 2.26758C13.0225 2.26758 13.2385 2.34172 13.414 2.47827L21.414 8.70027C21.5343 8.79384 21.6316 8.91365 21.6985 9.05057C21.7654 9.18749 21.8002 9.33788 21.8 9.49027V20.0003ZM7.80005 15.0003V17.0003H17.8V15.0003H7.80005Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const HomeInactive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M21.8 20.0003C21.8 20.2655 21.6947 20.5198 21.5072 20.7074C21.3196 20.8949 21.0653 21.0003 20.8 21.0003H4.80005C4.53483 21.0003 4.28048 20.8949 4.09294 20.7074C3.90541 20.5198 3.80005 20.2655 3.80005 20.0003V9.49027C3.79994 9.33788 3.83467 9.18749 3.90156 9.05057C3.96846 8.91365 4.06577 8.79384 4.18605 8.70027L12.186 2.47827C12.3616 2.34172 12.5776 2.26758 12.8 2.26758C13.0225 2.26758 13.2385 2.34172 13.414 2.47827L21.414 8.70027C21.5343 8.79384 21.6316 8.91365 21.6985 9.05057C21.7654 9.18749 21.8002 9.33788 21.8 9.49027V20.0003ZM19.8 19.0003V9.97827L12.8 4.53427L5.80005 9.97827V19.0003H19.8ZM7.80005 15.0003H17.8V17.0003H7.80005V15.0003Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Account = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="wallet-fill">
        <path
          id="Vector"
          d="M2.19971 9H21.1997C21.4649 9 21.7193 9.10536 21.9068 9.29289C22.0944 9.48043 22.1997 9.73478 22.1997 10V20C22.1997 20.2652 22.0944 20.5196 21.9068 20.7071C21.7193 20.8946 21.4649 21 21.1997 21H3.19971C2.93449 21 2.68014 20.8946 2.4926 20.7071C2.30506 20.5196 2.19971 20.2652 2.19971 20V9ZM3.19971 3H18.1997V7H2.19971V4C2.19971 3.73478 2.30506 3.48043 2.4926 3.29289C2.68014 3.10536 2.93449 3 3.19971 3ZM15.1997 14V16H18.1997V14H15.1997Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const AccountInactive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M18.2 7H21.2C21.4652 7 21.7195 7.10536 21.9071 7.29289C22.0946 7.48043 22.2 7.73478 22.2 8V20C22.2 20.2652 22.0946 20.5196 21.9071 20.7071C21.7195 20.8946 21.4652 21 21.2 21H3.19995C2.93473 21 2.68038 20.8946 2.49284 20.7071C2.30531 20.5196 2.19995 20.2652 2.19995 20V4C2.19995 3.73478 2.30531 3.48043 2.49284 3.29289C2.68038 3.10536 2.93473 3 3.19995 3H18.2V7ZM4.19995 9V19H20.2V9H4.19995ZM4.19995 5V7H16.2V5H4.19995ZM15.2 13H18.2V15H15.2V13Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Market = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.40002 3H21.4C21.6652 3 21.9196 3.10536 22.1071 3.29289C22.2947 3.48043 22.4 3.73478 22.4 4V20C22.4 20.2652 22.2947 20.5196 22.1071 20.7071C21.9196 20.8946 21.6652 21 21.4 21H3.40002C3.13481 21 2.88045 20.8946 2.69292 20.7071C2.50538 20.5196 2.40002 20.2652 2.40002 20V4C2.40002 3.73478 2.50538 3.48043 2.69292 3.29289C2.88045 3.10536 3.13481 3 3.40002 3ZM15.193 9.793L12.743 12.243L10.622 10.121L6.37902 14.364L7.79302 15.778L10.622 12.95L12.743 15.071L16.607 11.207L18.4 13V8H13.4L15.193 9.793Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MarketInactive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.40015 5V19H20.4001V5H4.40015ZM3.40015 3H21.4001C21.6654 3 21.9197 3.10536 22.1073 3.29289C22.2948 3.48043 22.4001 3.73478 22.4001 4V20C22.4001 20.2652 22.2948 20.5196 22.1073 20.7071C21.9197 20.8946 21.6654 21 21.4001 21H3.40015C3.13493 21 2.88058 20.8946 2.69304 20.7071C2.5055 20.5196 2.40015 20.2652 2.40015 20V4C2.40015 3.73478 2.5055 3.48043 2.69304 3.29289C2.88058 3.10536 3.13493 3 3.40015 3ZM15.1931 9.793L13.4001 8H18.4001V13L16.6071 11.207L12.7431 15.071L10.6221 12.95L7.79315 15.778L6.37915 14.364L10.6221 10.121L12.7431 12.243L15.1931 9.793Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Order = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.6001 15V3C3.6001 2.73478 3.70545 2.48043 3.89299 2.29289C4.08053 2.10536 4.33488 2 4.6001 2H20.6001C20.8653 2 21.1197 2.10536 21.3072 2.29289C21.4947 2.48043 21.6001 2.73478 21.6001 3V19C21.6001 19.7956 21.284 20.5587 20.7214 21.1213C20.1588 21.6839 19.3957 22 18.6001 22H4.6001C3.80445 22 3.04139 21.6839 2.47878 21.1213C1.91617 20.5587 1.6001 19.7956 1.6001 19V17H17.6001V19C17.6001 19.2652 17.7055 19.5196 17.893 19.7071C18.0805 19.8946 18.3349 20 18.6001 20C18.8653 20 19.1197 19.8946 19.3072 19.7071C19.4947 19.5196 19.6001 19.2652 19.6001 19V15H3.6001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const OrderInactive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6001 17V19C17.6001 19.2652 17.7055 19.5196 17.893 19.7071C18.0805 19.8946 18.3349 20 18.6001 20C18.8653 20 19.1197 19.8946 19.3072 19.7071C19.4947 19.5196 19.6001 19.2652 19.6001 19V4H5.6001V15H3.6001V3C3.6001 2.73478 3.70545 2.48043 3.89299 2.29289C4.08053 2.10536 4.33488 2 4.6001 2H20.6001C20.8653 2 21.1197 2.10536 21.3072 2.29289C21.4947 2.48043 21.6001 2.73478 21.6001 3V19C21.6001 19.7956 21.284 20.5587 20.7214 21.1213C20.1588 21.6839 19.3957 22 18.6001 22H4.6001C3.80445 22 3.04139 21.6839 2.47878 21.1213C1.91617 20.5587 1.6001 19.7956 1.6001 19V17H17.6001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Trade = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="exchange-fill">
        <path
          id="Vector"
          d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 9H8V11H17L12 6V9ZM7 13L12 18V15H16V13H7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TradeInactive = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM7 13H16V15H12V18L7 13ZM12 9V6L17 11H8V9H12Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Loading = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      className={clsx('animate-spin', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );
};

export const Loading2 = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      className={clsx('animate-spin', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Star = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.02317 7.29261C4.68731 7.8018 6.78342 9.89791 7.29261 12.562C7.8018 9.89791 9.89791 7.8018 12.562 7.29261C9.89791 6.78342 7.8018 4.68731 7.29261 2.02317C6.78342 4.68731 4.68731 6.78342 2.02317 7.29261ZM1 7.17835C4.36097 7.05771 7.05771 4.36097 7.17835 1H7.40687C7.5275 4.36097 10.2242 7.05771 13.5852 7.17835V7.40687C10.2242 7.5275 7.5275 10.2242 7.40687 13.5852H7.17835C7.05771 10.2242 4.36097 7.5275 1 7.40687V7.17835Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.560694"
      />
    </svg>
  );
};

export const Language = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.235 6.453C4.96004 7.77629 4.1795 9.49815 4.02457 11.3292C3.86964 13.1602 4.34977 14.9887 5.38426 16.5074C6.41874 18.0261 7.94451 19.1424 9.70511 19.6686C11.4657 20.1948 13.3538 20.0989 15.052 19.397C15.167 18.647 14.915 17.927 14.812 17.675C14.582 17.115 13.824 16.158 12.559 14.831C12.221 14.476 12.243 14.203 12.364 13.394L12.377 13.303C12.459 12.749 12.597 12.421 14.462 12.125C15.41 11.975 15.659 12.353 16.004 12.878L16.12 13.05C16.448 13.53 16.691 13.64 17.058 13.806C17.223 13.881 17.428 13.976 17.703 14.131C18.355 14.504 18.355 14.925 18.355 15.847V15.952C18.355 16.343 18.317 16.687 18.257 16.986C19.0244 16.0229 19.5591 14.8957 19.8196 13.6922C20.0801 12.4886 20.0593 11.2412 19.7588 10.047C19.4584 8.85284 18.8863 7.7441 18.0873 6.80714C17.2883 5.87017 16.2838 5.13026 15.152 4.645C14.599 5.018 13.84 5.547 13.575 5.91C13.44 6.095 13.248 7.042 12.625 7.12C12.463 7.14 12.244 7.126 12.012 7.111C11.39 7.071 10.54 7.016 10.268 7.755C10.095 8.223 10.065 9.495 10.624 10.155C10.714 10.26 10.731 10.455 10.67 10.674C10.59 10.961 10.429 11.136 10.378 11.172C10.282 11.116 10.09 10.893 9.959 10.742C9.646 10.377 9.254 9.922 8.748 9.782C8.564 9.731 8.362 9.689 8.165 9.647C7.616 9.532 6.995 9.401 6.85 9.093C6.744 8.867 6.745 8.556 6.745 8.228C6.745 7.811 6.745 7.34 6.541 6.883C6.47008 6.71991 6.36585 6.57344 6.235 6.453ZM12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Theme = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20V4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightLineArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.172 10.9997L10.808 5.63568L12.222 4.22168L20 11.9997L12.222 19.7777L10.808 18.3637L16.172 12.9997H4V10.9997H16.172Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightArrowTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.5303 12.5303C18.8232 12.2374 18.8232 11.7626 18.5303 11.4697L13.7574 6.6967C13.4645 6.40381 12.9896 6.40381 12.6967 6.6967C12.4038 6.98959 12.4038 7.46447 12.6967 7.75736L16.9393 12L12.6967 16.2426C12.4038 16.5355 12.4038 17.0104 12.6967 17.3033C12.9896 17.5962 13.4645 17.5962 13.7574 17.3033L18.5303 12.5303ZM6 12.75L18 12.75V11.25L6 11.25V12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.9766 10.0006L6.85156 5.8756L8.0299 4.69727L13.3332 10.0006L8.0299 15.3039L6.85156 14.1256L10.9766 10.0006Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DoubleRightArrow = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        opacity="0.4"
        d="M4.45487 8L0 3.33312L1.27256 2L7 8L1.27256 14L0 12.6669L4.45487 8Z"
        fill="currentColor"
      />
      <path
        opacity="0.2"
        d="M12.4549 8L8 3.33312L9.27256 2L15 8L9.27256 14L8 12.6669L12.4549 8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Use = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 18.5V5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2H20C20.2652 2 20.5196 2.10536 20.7071 2.29289C20.8946 2.48043 21 2.73478 21 3V21C21 21.2652 20.8946 21.5196 20.7071 21.7071C20.5196 21.8946 20.2652 22 20 22H6.5C5.57174 22 4.6815 21.6313 4.02513 20.9749C3.36875 20.3185 3 19.4283 3 18.5ZM19 20V17H6.5C6.10218 17 5.72064 17.158 5.43934 17.4393C5.15804 17.7206 5 18.1022 5 18.5C5 18.8978 5.15804 19.2794 5.43934 19.5607C5.72064 19.842 6.10218 20 6.5 20H19ZM5 15.337C5.46869 15.1144 5.98115 14.9993 6.5 15H19V4H6C5.73478 4 5.48043 4.10536 5.29289 4.29289C5.10536 4.48043 5 4.73478 5 5V15.337Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Community = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12.487C1.99998 12.3441 2.03059 12.2029 2.08976 12.0728C2.14892 11.9428 2.23528 11.8269 2.343 11.733L6 8.544V4C6 3.73478 6.10536 3.48043 6.29289 3.29289C6.48043 3.10536 6.73478 3 7 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM9 19H12V12.942L8 9.454L4 12.942V19H7V15H9V19ZM14 19H20V5H8V7.127C8.234 7.127 8.469 7.209 8.657 7.374L13.657 11.733C13.7647 11.8269 13.8511 11.9428 13.9102 12.0728C13.9694 12.2029 14 12.3441 14 12.487V19ZM16 11H18V13H16V11ZM16 15H18V17H16V15ZM16 7H18V9H16V7ZM12 7H14V9H12V7Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const X = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6666 20L13.4096 10.6749L13.4203 10.6836L19.0619 4H17.1766L12.5808 9.44L8.93117 4H3.98676L9.82829 12.7062L9.82758 12.7055L3.66663 20H5.55191L10.6614 13.9476L14.7222 20H19.6666ZM8.18418 5.45454L16.9632 18.5455H15.4692L6.6831 5.45454H8.18418Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Instagram = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9ZM12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7ZM18.5 6.75C18.5 7.08152 18.3683 7.39946 18.1339 7.63388C17.8995 7.8683 17.5815 8 17.25 8C16.9185 8 16.6005 7.8683 16.3661 7.63388C16.1317 7.39946 16 7.08152 16 6.75C16 6.41848 16.1317 6.10054 16.3661 5.86612C16.6005 5.6317 16.9185 5.5 17.25 5.5C17.5815 5.5 17.8995 5.6317 18.1339 5.86612C18.3683 6.10054 18.5 6.41848 18.5 6.75ZM12 4C9.526 4 9.122 4.007 7.971 4.058C7.187 4.095 6.661 4.2 6.173 4.39C5.739 4.558 5.426 4.759 5.093 5.093C4.78001 5.3954 4.53935 5.76458 4.389 6.173C4.199 6.663 4.094 7.188 4.058 7.971C4.006 9.075 4 9.461 4 12C4 14.474 4.007 14.878 4.058 16.029C4.095 16.812 4.2 17.339 4.389 17.826C4.559 18.261 4.759 18.574 5.091 18.906C5.428 19.242 5.741 19.443 6.171 19.609C6.665 19.8 7.191 19.906 7.971 19.942C9.075 19.994 9.461 20 12 20C14.474 20 14.878 19.993 16.029 19.942C16.811 19.905 17.338 19.8 17.826 19.611C18.259 19.442 18.574 19.241 18.906 18.909C19.243 18.572 19.444 18.259 19.61 17.829C19.8 17.336 19.906 16.809 19.942 16.029C19.994 14.925 20 14.539 20 12C20 9.526 19.993 9.122 19.942 7.971C19.905 7.189 19.8 6.661 19.61 6.173C19.4593 5.765 19.2191 5.39596 18.907 5.093C18.6047 4.77985 18.2355 4.53917 17.827 4.389C17.337 4.199 16.811 4.094 16.029 4.058C14.925 4.006 14.539 4 12 4ZM12 2C14.717 2 15.056 2.01 16.122 2.06C17.187 2.11 17.912 2.277 18.55 2.525C19.21 2.779 19.766 3.123 20.322 3.678C20.8305 4.1779 21.224 4.78259 21.475 5.45C21.722 6.087 21.89 6.813 21.94 7.878C21.987 8.944 22 9.283 22 12C22 14.717 21.99 15.056 21.94 16.122C21.89 17.187 21.722 17.912 21.475 18.55C21.2247 19.2178 20.8311 19.8226 20.322 20.322C19.822 20.8303 19.2173 21.2238 18.55 21.475C17.913 21.722 17.187 21.89 16.122 21.94C15.056 21.987 14.717 22 12 22C9.283 22 8.944 21.99 7.878 21.94C6.813 21.89 6.088 21.722 5.45 21.475C4.78233 21.2245 4.17753 20.8309 3.678 20.322C3.16941 19.8222 2.77593 19.2175 2.525 18.55C2.277 17.913 2.11 17.187 2.06 16.122C2.013 15.056 2 14.717 2 12C2 9.283 2.01 8.944 2.06 7.878C2.11 6.812 2.277 6.088 2.525 5.45C2.77524 4.78218 3.1688 4.17732 3.678 3.678C4.17767 3.16923 4.78243 2.77573 5.45 2.525C6.088 2.277 6.812 2.11 7.878 2.06C8.944 2.013 9.283 2 12 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Security = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 1L20.217 2.826C20.674 2.928 21 3.333 21 3.802V13.789C21 15.795 19.997 17.669 18.328 18.781L12 23L5.672 18.781C4.002 17.668 3 15.795 3 13.79V3.802C3 3.333 3.326 2.928 3.783 2.826L12 1ZM12 3.049L5 4.604V13.789C5 15.126 5.668 16.375 6.781 17.117L12 20.597L17.219 17.117C18.332 16.375 19 15.127 19 13.79V4.604L12 3.049ZM16.192 8.222L17.607 9.636L11.243 16L7 11.757L8.414 10.343L11.242 13.171L16.192 8.221V8.222Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Newspaper = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M18.6667 23.3333V4.66668H4.66671V22.1667C4.66671 22.4761 4.78962 22.7728 5.00842 22.9916C5.22721 23.2104 5.52395 23.3333 5.83337 23.3333H18.6667ZM22.1667 25.6667H5.83337C4.90512 25.6667 4.01488 25.2979 3.3585 24.6416C2.70212 23.9852 2.33337 23.0949 2.33337 22.1667V3.50001C2.33337 3.19059 2.45629 2.89384 2.67508 2.67505C2.89388 2.45626 3.19062 2.33334 3.50004 2.33334H19.8334C20.1428 2.33334 20.4395 2.45626 20.6583 2.67505C20.8771 2.89384 21 3.19059 21 3.50001V11.6667H25.6667V22.1667C25.6667 23.0949 25.298 23.9852 24.6416 24.6416C23.9852 25.2979 23.095 25.6667 22.1667 25.6667ZM21 14V22.1667C21 22.4761 21.123 22.7728 21.3417 22.9916C21.5605 23.2104 21.8573 23.3333 22.1667 23.3333C22.4761 23.3333 22.7729 23.2104 22.9917 22.9916C23.2105 22.7728 23.3334 22.4761 23.3334 22.1667V14H21ZM7.00004 7.00001H14V14H7.00004V7.00001ZM9.33337 9.33334V11.6667H11.6667V9.33334H9.33337ZM7.00004 15.1667H16.3334V17.5H7.00004V15.1667ZM7.00004 18.6667H16.3334V21H7.00004V18.6667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const SecurityTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <g clipPath="url(#clip0_372_65548)">
        <path
          d="M10 0.939453L16.8475 2.46112C17.0325 2.50226 17.198 2.60526 17.3167 2.75312C17.4353 2.90099 17.5 3.08488 17.5 3.27445V11.597C17.4999 12.4201 17.2967 13.2304 16.9082 13.9561C16.5198 14.6818 15.9582 15.3004 15.2733 15.757L10 19.2728L4.72667 15.757C4.04189 15.3005 3.48038 14.682 3.09196 13.9565C2.70353 13.231 2.5002 12.4208 2.5 11.5978V3.27445C2.50003 3.08488 2.5647 2.90099 2.68332 2.75312C2.80195 2.60526 2.96745 2.50226 3.1525 2.46112L10 0.939453ZM10 2.64695L4.16667 3.94279V11.597C4.16668 12.1457 4.30215 12.6859 4.56105 13.1697C4.81996 13.6535 5.19429 14.0659 5.65083 14.3703L10 17.2703L14.3492 14.3703C14.8056 14.066 15.1799 13.6537 15.4388 13.1701C15.6977 12.6864 15.8332 12.1464 15.8333 11.5978V3.94279L10 2.64779V2.64695ZM10 5.93945C10.3669 5.93929 10.7237 6.06022 11.0149 6.2835C11.3061 6.50678 11.5155 6.81993 11.6105 7.17435C11.7056 7.52877 11.681 7.90465 11.5407 8.24369C11.4003 8.58273 11.1519 8.86596 10.8342 9.04945L10.8333 12.6061H9.16667V9.04945C8.84895 8.866 8.60065 8.58284 8.46026 8.24388C8.31987 7.90493 8.29524 7.52912 8.3902 7.17475C8.48515 6.82037 8.69439 6.50723 8.98544 6.28388C9.2765 6.06054 9.63312 5.93947 10 5.93945Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_372_65548">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(0 0.105957)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Term = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16 20V4H4V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H16ZM19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H17C17.2652 2 17.5196 2.10536 17.7071 2.29289C17.8946 2.48043 18 2.73478 18 3V10H22V19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22ZM18 12V19C18 19.2652 18.1054 19.5196 18.2929 19.7071C18.4804 19.8946 18.7348 20 19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V12H18ZM6 6H12V12H6V6ZM8 8V10H10V8H8ZM6 13H14V15H6V13ZM6 16H14V18H6V16Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Policy = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 13V14C17 16.77 16.336 19.445 15.085 21.846L14.858 22.266L13.111 21.292C14.271 19.212 14.921 16.882 14.993 14.456L15 14V13H17ZM11 9.99999H13V14L12.995 14.379C12.9194 17.1167 11.9772 19.7598 10.304 21.928L10.073 22.218L8.523 20.954C10.0494 19.0899 10.918 16.7741 10.994 14.366L11 14V9.99999ZM12 5.99999C13.3261 5.99999 14.5979 6.52678 15.5355 7.46446C16.4732 8.40214 17 9.67391 17 11H15C15 10.2043 14.6839 9.44128 14.1213 8.87867C13.5587 8.31606 12.7956 7.99999 12 7.99999C11.2043 7.99999 10.4413 8.31606 9.87868 8.87867C9.31607 9.44128 9 10.2043 9 11V14C9 16.235 8.18 18.344 6.729 19.977L6.517 20.207L5.069 18.827C6.23896 17.6029 6.92324 15.9948 6.994 14.303L7 14V11C7 9.67391 7.52678 8.40214 8.46447 7.46446C9.40215 6.52678 10.6739 5.99999 12 5.99999ZM12 1.99999C14.3869 1.99999 16.6761 2.94821 18.364 4.63603C20.0518 6.32386 21 8.61305 21 11V14C21 15.698 20.798 17.37 20.403 18.99L20.264 19.529L18.334 19.003C18.726 17.566 18.947 16.081 18.992 14.568L19 14V11C19 9.70086 18.6385 8.42735 17.9559 7.322C17.2733 6.21664 16.2965 5.32305 15.135 4.74123C13.9734 4.15941 12.6728 3.91232 11.3788 4.0276C10.0848 4.14288 8.84842 4.616 7.808 5.39399L6.383 3.96799C7.97647 2.69127 9.95815 1.99697 12 1.99999ZM4.968 5.38299L6.394 6.80799C5.53633 7.95122 5.05106 9.33059 5.004 10.759L5 11L5.004 13C5.004 14.12 4.74 15.203 4.242 16.177L4.086 16.467L2.349 15.475C2.729 14.81 2.951 14.068 2.995 13.292L3.004 13V11C2.99807 8.95833 3.69115 6.97613 4.968 5.38299Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeftArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
    >
      <path
        d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM19 7L1 7V9L19 9V7Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeftDwonArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M15.0904 16.0044L6.48242 7.3974L7.89642 5.9834L16.5034 14.5894V7.0044H18.5034V18.0044H7.50342V16.0044H15.0904Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightUpArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3367 7.845L6.16417 15.0175L4.98584 13.8392L12.1575 6.66667H5.83667V5H15.0033V14.1667H13.3367V7.845Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RightLeftArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M5.00334 9.11111L19.0033 9.11111L15.9033 6M20.0033 14.7778H6.00334L9.10334 17.8889"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </svg>
  );
};

export const DownArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M13.6667 16.172L19.0307 10.808L20.4447 12.222L12.6667 20L4.88867 12.222L6.30267 10.808L11.6667 16.172V4H13.6667V16.172Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UpArrow = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 7.828V20H11V7.828L5.63598 13.192L4.22198 11.778L12 4L19.778 11.778L18.364 13.192L13 7.828Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownTriangle = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M8 10L3 5H13L8 10Z" fill="currentColor" />
    </svg>
  );
};

export const Bitpoints = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <path
        d="M23.9103 11.6817C23.947 11.6074 24.053 11.6074 24.0897 11.6817L27.6504 18.8965C27.665 18.926 27.6931 18.9465 27.7257 18.9512L35.6877 20.1082C35.7697 20.1201 35.8025 20.2209 35.7431 20.2787L29.9818 25.8947C29.9582 25.9176 29.9474 25.9507 29.953 25.9832L31.3131 33.913C31.3271 33.9947 31.2413 34.057 31.168 34.0184L24.0465 30.2745C24.0174 30.2592 23.9826 30.2592 23.9535 30.2745L16.832 34.0184C16.7587 34.057 16.6729 33.9947 16.6869 33.913L18.047 25.9832C18.0526 25.9507 18.0418 25.9176 18.0183 25.8947L12.2569 20.2787C12.1975 20.2209 12.2303 20.1201 12.3123 20.1082L20.2743 18.9512C20.3069 18.9465 20.335 18.926 20.3496 18.8965L23.9103 11.6817Z"
        stroke="currentColor"
        strokeWidth="3"
      />
      <circle
        cx="24"
        cy="24"
        r="22"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Gift = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0226 2.08097C17.1391 1.37416 16.1447 1.38285 15.2811 1.73192C14.4696 2.05994 13.7311 2.69504 13.1241 3.34706C12.5352 3.97971 12.0016 4.70401 11.5781 5.36009C11.2603 4.78048 10.868 4.14785 10.4218 3.57751C9.93045 2.94948 9.31529 2.32038 8.59609 1.95603C7.82974 1.56779 6.91735 1.47563 6.02605 2.01039C5.14912 2.53653 4.73845 3.41464 4.69903 4.33048C4.66064 5.22247 4.96524 6.16165 5.49837 6.99471C5.92616 7.66316 6.51784 8.29075 7.25356 8.80424H4.69576H3.78271V9.71729V14.2825V15.1955H4.69576H4.6958V21.5861V22.4991H5.60884H18.3914H19.3045V21.5861V15.1955H20.2175V14.2825V9.71729V8.80424H19.3044H16.5592C17.19 8.44422 17.743 8.02308 18.1922 7.55919C18.9158 6.812 19.4327 5.88422 19.4583 4.86703C19.4848 3.81208 18.9789 2.84601 18.0226 2.08097ZM12.3689 7.68827C12.5411 7.24386 13.388 5.74359 14.4607 4.59133C14.9975 4.01469 15.5184 3.60564 15.9654 3.42493C16.3604 3.26528 16.624 3.30067 16.8818 3.5069C17.4834 3.98817 17.6423 4.4441 17.6328 4.82109C17.6223 5.23583 17.4023 5.74994 16.8804 6.28884C15.8321 7.37134 13.8196 8.27158 11.5173 8.27158C9.3275 8.27158 7.78693 7.18307 7.03645 6.01039C6.65658 5.41682 6.50471 4.84377 6.52343 4.409C6.54111 3.99808 6.70114 3.73489 6.96554 3.57626C7.21559 3.42623 7.44827 3.42159 7.77084 3.585C8.14057 3.77231 8.55819 4.159 8.9836 4.70274C9.82662 5.78024 10.4715 7.17471 10.6637 7.68202C10.7977 8.03573 11.1359 8.27018 11.5142 8.27157C11.8924 8.27295 12.2323 8.04098 12.3689 7.68827ZM17.4784 15.1955H6.52188V20.673H17.4784V15.1955ZM18.3914 10.6303V13.3687H5.60884H5.6088V10.6303H18.3914Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GiftTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M14.7712 6.50642H10.6751C10.3919 6.50642 10.1745 6.44702 10.0228 6.32822C9.87105 6.20942 9.76485 6.05863 9.70417 5.87586C9.64349 5.69309 9.61315 5.48748 9.61315 5.25902C9.61315 5.03056 9.63338 4.81581 9.67383 4.61476C9.69406 4.41371 9.73451 4.19439 9.7952 3.95679C9.85588 3.71919 9.94185 3.51815 10.0531 3.35366C10.1643 3.18917 10.311 3.0795 10.493 3.02467C10.6751 2.96984 10.8976 3.01554 11.1606 3.16175C11.464 3.32624 11.8078 3.50444 12.1922 3.69635C12.5765 3.88826 12.9507 4.08016 13.3148 4.27207C13.6789 4.46398 14.0177 4.63761 14.3312 4.79296C14.6448 4.94831 14.8824 5.07168 15.0442 5.16307C15.2465 5.291 15.3982 5.43265 15.4994 5.588C15.6005 5.74336 15.641 5.88957 15.6207 6.02665C15.6005 6.16372 15.5196 6.27795 15.378 6.36934C15.2364 6.46072 15.0341 6.50642 14.7712 6.50642ZM17.1378 6.479H21.2035C21.4867 6.479 21.7042 6.4196 21.8559 6.3008C22.0076 6.182 22.1138 6.03122 22.1745 5.84845C22.2351 5.66568 22.2655 5.46007 22.2655 5.2316C22.2655 5.00314 22.2554 4.78839 22.2351 4.58735C22.1947 4.3863 22.1492 4.17155 22.0986 3.94309C22.048 3.71463 21.9671 3.51815 21.8559 3.35366C21.7446 3.18917 21.598 3.0795 21.4159 3.02467C21.2339 2.96984 21.0114 3.0064 20.7484 3.13433C20.445 3.29883 20.1011 3.47703 19.7168 3.66893C19.3325 3.86084 18.9532 4.05275 18.579 4.24465C18.2048 4.43656 17.8609 4.61019 17.5474 4.76554C17.2339 4.9209 17.0063 5.04427 16.8647 5.13565C16.6422 5.26359 16.4804 5.40523 16.3793 5.56059C16.2781 5.71594 16.2377 5.86216 16.2579 5.99923C16.2781 6.13631 16.359 6.25054 16.5006 6.34192C16.6422 6.43331 16.8546 6.479 17.1378 6.479ZM14.3464 8.28841H5.54741C4.90013 8.28841 4.4804 8.38436 4.28824 8.57627C4.09608 8.76818 4 9.07431 4 9.49468V11.9072C4 12.3641 4.10619 12.7023 4.31858 12.9216C4.53097 13.1409 4.9507 13.2506 5.57775 13.2506H14.3464V8.28841ZM17.6536 8.28841H26.3312C26.9785 8.28841 27.4185 8.40264 27.6511 8.6311C27.8837 8.85956 28 9.18397 28 9.60434V11.9621C28 12.4007 27.8938 12.7251 27.6814 12.9353C27.469 13.1455 27.0493 13.2506 26.4223 13.2506H17.6536V8.28841ZM14.3464 14.7036H5.03161V19.1997V20.9817V22.654V24.0796V25.0666C5.03161 25.9987 5.32491 26.7206 5.9115 27.2324C6.4981 27.7441 7.40834 28 8.64223 28H14.3464V14.7036ZM17.6536 14.7036H26.9381V24.9843C26.9178 25.9164 26.6245 26.6521 26.0582 27.1912C25.4918 27.7304 24.5917 28 23.3578 28H17.6536V14.7036Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StarTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968L16.2469 18.345L15.2979 13.572L18.8709 10.267L14.0379 9.694L11.9999 5.275L9.96191 9.695L5.12891 10.267L8.70191 13.572L7.75291 18.345L11.9999 15.968Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StarThree = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="85"
      height="80"
      viewBox="0 0 85 80"
      fill="none"
    >
      <path
        d="M41.5629 1.51511C41.8863 0.647287 43.1137 0.647285 43.4371 1.51511L53.4742 28.4547C53.6146 28.8315 53.967 29.0876 54.3688 29.1047L83.0915 30.3257C84.0168 30.3651 84.3961 31.5325 83.6706 32.1082L61.1512 49.9788C60.8362 50.2288 60.7016 50.6431 60.8095 51.0305L68.524 78.7247C68.7725 79.6168 67.7795 80.3383 67.0078 79.8263L43.0529 63.9314C42.7178 63.709 42.2822 63.709 41.9471 63.9314L17.9922 79.8263C17.2206 80.3383 16.2275 79.6168 16.476 78.7247L24.1905 51.0305C24.2984 50.6431 24.1638 50.2288 23.8488 49.9788L1.32937 32.1082C0.603935 31.5325 0.983247 30.3651 1.90851 30.3257L30.6312 29.1047C31.033 29.0876 31.3854 28.8315 31.5258 28.4547L41.5629 1.51511Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const BitCoin = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <rect
        x="0.375"
        y="0.375"
        width="15.25"
        height="15.25"
        rx="7.625"
        stroke="currentColor"
        strokeWidth="0.75"
      />
      <path
        d="M10.6401 6.12915V9.75528M5.84082 8.05448H10.6401M9.03151 4.79883H5.84082V11.1979H9.03151"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Coin = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M13 7V8H15V10H11C10.8751 9.99977 10.7545 10.0463 10.6622 10.1305C10.5699 10.2147 10.5124 10.3304 10.5011 10.4548C10.4898 10.5793 10.5255 10.7034 10.6012 10.8028C10.6769 10.9023 10.7871 10.9697 10.91 10.992L11 11H13C13.663 11 14.2989 11.2634 14.7678 11.7322C15.2366 12.2011 15.5 12.837 15.5 13.5C15.5 14.163 15.2366 14.7989 14.7678 15.2678C14.2989 15.7366 13.663 16 13 16V17H11V16H9V14H13C13.1249 14.0002 13.2455 13.9537 13.3378 13.8695C13.4301 13.7853 13.4876 13.6696 13.4989 13.5452C13.5102 13.4207 13.4745 13.2966 13.3988 13.1972C13.3231 13.0977 13.2129 13.0303 13.09 13.008L13 13H11C10.337 13 9.70107 12.7366 9.23223 12.2678C8.76339 11.7989 8.5 11.163 8.5 10.5C8.5 9.83696 8.76339 9.20107 9.23223 8.73223C9.70107 8.26339 10.337 8 11 8V7H13Z"
        fill="currentColor"
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const CoinLine = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.2388 3.30273C14.9331 3.30273 18.7388 5.48511 18.7388 8.17773V11.4277C18.7388 14.1204 14.9331 16.3027 10.2388 16.3027C5.62791 16.3027 1.87477 14.1975 1.74263 11.5715L1.73877 11.4277V8.17773C1.73877 5.48511 5.54445 3.30273 10.2388 3.30273ZM10.2388 13.0527C7.36422 13.0527 4.82195 12.2345 3.28422 10.9809V11.4277C3.28422 12.9569 6.28472 14.6777 10.2388 14.6777C14.1101 14.6777 17.0681 13.0284 17.1895 11.5236L17.1933 11.4277L17.1941 10.9809C15.6564 12.2337 13.1141 13.0527 10.2388 13.0527ZM10.2388 4.92773C6.28472 4.92773 3.28422 6.64861 3.28422 8.17773C3.28422 9.70686 6.28472 11.4277 10.2388 11.4277C14.1928 11.4277 17.1933 9.70686 17.1933 8.17773C17.1933 6.64861 14.1928 4.92773 10.2388 4.92773Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CoinTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14 2C15.8299 1.99913 17.6049 2.62567 19.0288 3.77513C20.4527 4.92458 21.4395 6.52748 21.8246 8.31647C22.2097 10.1055 21.9699 11.9724 21.145 13.6059C20.3202 15.2395 18.9602 16.5408 17.292 17.293C16.7587 18.4719 15.9475 19.5039 14.9278 20.3004C13.9082 21.097 12.7105 21.6343 11.4376 21.8663C10.1647 22.0984 8.85446 22.0182 7.61933 21.6327C6.3842 21.2472 5.261 20.5678 4.34608 19.6529C3.43115 18.738 2.7518 17.6148 2.36628 16.3796C1.98076 15.1445 1.90058 13.8343 2.13262 12.5614C2.36466 11.2884 2.90199 10.0908 3.69854 9.07114C4.49508 8.05148 5.52705 7.24024 6.70596 6.707C7.34011 5.30389 8.36555 4.1135 9.65931 3.27861C10.9531 2.44371 12.4602 1.99976 14 2ZM9.99996 8C9.21203 8 8.43182 8.1552 7.70386 8.45672C6.97591 8.75825 6.31447 9.20021 5.75732 9.75736C5.20017 10.3145 4.75822 10.9759 4.45669 11.7039C4.15516 12.4319 3.99996 13.2121 3.99996 14C3.99996 14.7879 4.15516 15.5681 4.45669 16.2961C4.75822 17.0241 5.20017 17.6855 5.75732 18.2426C6.31447 18.7998 6.97591 19.2417 7.70386 19.5433C8.43182 19.8448 9.21203 20 9.99996 20C11.5913 20 13.1174 19.3679 14.2426 18.2426C15.3678 17.1174 16 15.5913 16 14C16 12.4087 15.3678 10.8826 14.2426 9.75736C13.1174 8.63214 11.5913 8 9.99996 8ZM11 9V10H13V12H8.99996C8.87502 11.9998 8.75451 12.0463 8.66218 12.1305C8.56985 12.2147 8.51238 12.3304 8.50109 12.4548C8.4898 12.5793 8.52551 12.7034 8.60118 12.8028C8.67686 12.9023 8.78702 12.9697 8.90996 12.992L8.99996 13H11C11.663 13 12.2989 13.2634 12.7677 13.7322C13.2366 14.2011 13.5 14.837 13.5 15.5C13.5 16.163 13.2366 16.7989 12.7677 17.2678C12.2989 17.7366 11.663 18 11 18V19H8.99996V18H6.99996V16H11C11.1249 16.0002 11.2454 15.9537 11.3377 15.8695C11.4301 15.7853 11.4875 15.6696 11.4988 15.5452C11.5101 15.4207 11.4744 15.2966 11.3987 15.1972C11.3231 15.0977 11.2129 15.0303 11.09 15.008L11 15H8.99996C8.33692 15 7.70104 14.7366 7.2322 14.2678C6.76336 13.7989 6.49996 13.163 6.49996 12.5C6.49996 11.837 6.76336 11.2011 7.2322 10.7322C7.70104 10.2634 8.33692 10 8.99996 10V9H11ZM14 4C13.1526 3.99901 12.3148 4.17794 11.5418 4.52496C10.7688 4.87198 10.0783 5.37918 9.51596 6.013C10.6462 5.94439 11.7782 6.1165 12.837 6.51795C13.8958 6.9194 14.8573 7.54105 15.6579 8.34178C16.4586 9.14252 17.0801 10.1041 17.4814 11.1629C17.8827 12.2218 18.0547 13.3537 17.986 14.484C18.8952 13.6756 19.5372 12.6099 19.8268 11.4283C20.1164 10.2467 20.04 9.00492 19.6076 7.86772C19.1752 6.73053 18.4074 5.75164 17.4059 5.06088C16.4044 4.37013 15.2166 4.00014 14 4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CoinFill = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
    >
      <path
        d="M22 8V10C22 13.314 17.075 16 11 16C5.033 16 0.176 13.409 0.005 10.177L0 10V8C0 11.314 4.925 14 11 14C17.075 14 22 11.314 22 8ZM11 0C17.075 0 22 2.686 22 6C22 9.314 17.075 12 11 12C4.925 12 0 9.314 0 6C0 2.686 4.925 0 11 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Share = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M8.83333 3V4.66667H4.66667V16.3333H16.3333V12.1667H18V17.1667C18 17.3877 17.9122 17.5996 17.7559 17.7559C17.5996 17.9122 17.3877 18 17.1667 18H3.83333C3.61232 18 3.40036 17.9122 3.24408 17.7559C3.0878 17.5996 3 17.3877 3 17.1667V3.83333C3 3.61232 3.0878 3.40036 3.24408 3.24408C3.40036 3.0878 3.61232 3 3.83333 3H8.83333ZM15.155 4.66667H11.3333V3H18V9.66667H16.3333V5.845L10.5 11.6783L9.32167 10.5L15.155 4.66667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShareTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="external-link-line">
        <path
          id="Vector"
          d="M6.66667 4V5.33333H3.33333V12.6667H10.6667V9.33333H12V13.3333C12 13.5101 11.9298 13.6797 11.8047 13.8047C11.6797 13.9298 11.5101 14 11.3333 14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V4.66667C2 4.48986 2.07024 4.32029 2.19526 4.19526C2.32029 4.07024 2.48986 4 2.66667 4H6.66667ZM14 2V7.33333H12.6667V4.27533L7.47133 9.47133L6.52867 8.52867L11.7233 3.33333H8.66667V2H14Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const ShareThree = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10 3V5H5V19H19V14H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3H10ZM17.707 7.707L12 13.414L10.586 12L16.293 6.293L13 3H21V11L17.707 7.707Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShareLine = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M8.74664 11.3485L5.94731 9.82181C5.58184 10.2125 5.1073 10.4843 4.58536 10.6017C4.06342 10.7192 3.51821 10.677 3.02059 10.4805C2.52297 10.284 2.09595 9.94245 1.79502 9.50011C1.49409 9.05777 1.33317 8.53514 1.33317 8.00014C1.33317 7.46515 1.49409 6.94252 1.79502 6.50018C2.09595 6.05784 2.52297 5.71624 3.02059 5.51978C3.51821 5.32332 4.06342 5.28108 4.58536 5.39855C5.1073 5.51602 5.58184 5.78777 5.94731 6.17848L8.74731 4.65181C8.58835 4.02253 8.66435 3.35687 8.96106 2.77961C9.25778 2.20235 9.75485 1.75313 10.3591 1.51614C10.9633 1.27916 11.6333 1.27068 12.2433 1.4923C12.8533 1.71392 13.3616 2.15042 13.6728 2.71998C13.9841 3.28955 14.0769 3.95307 13.9339 4.58617C13.7909 5.21928 13.4219 5.7785 12.8961 6.15902C12.3703 6.53953 11.7238 6.71522 11.0777 6.65314C10.4316 6.59106 9.83038 6.29548 9.38664 5.82181L6.58664 7.34848C6.69411 7.77605 6.69411 8.22357 6.58664 8.65114L9.38598 10.1778C9.82971 9.70414 10.431 9.40856 11.077 9.34648C11.7231 9.2844 12.3697 9.46009 12.8955 9.8406C13.4213 10.2211 13.7903 10.7803 13.9332 11.4134C14.0762 12.0466 13.9834 12.7101 13.6722 13.2796C13.3609 13.8492 12.8527 14.2857 12.2426 14.5073C11.6326 14.7289 10.9627 14.7205 10.3584 14.4835C9.75418 14.2465 9.25712 13.7973 8.9604 13.22C8.66368 12.6428 8.58768 11.9771 8.74664 11.3478V11.3485ZM3.99998 9.33314C4.3536 9.33314 4.69274 9.19267 4.94279 8.94262C5.19283 8.69257 5.33331 8.35343 5.33331 7.99981C5.33331 7.64619 5.19283 7.30705 4.94279 7.057C4.69274 6.80695 4.3536 6.66648 3.99998 6.66648C3.64635 6.66648 3.30722 6.80695 3.05717 7.057C2.80712 7.30705 2.66664 7.64619 2.66664 7.99981C2.66664 8.35343 2.80712 8.69257 3.05717 8.94262C3.30722 9.19267 3.64635 9.33314 3.99998 9.33314ZM11.3333 5.33314C11.6869 5.33314 12.0261 5.19267 12.2761 4.94262C12.5262 4.69257 12.6666 4.35343 12.6666 3.99981C12.6666 3.64619 12.5262 3.30705 12.2761 3.057C12.0261 2.80695 11.6869 2.66648 11.3333 2.66648C10.9797 2.66648 10.6405 2.80695 10.3905 3.057C10.1405 3.30705 9.99998 3.64619 9.99998 3.99981C9.99998 4.35343 10.1405 4.69257 10.3905 4.94262C10.6405 5.19267 10.9797 5.33314 11.3333 5.33314ZM11.3333 13.3331C11.6869 13.3331 12.0261 13.1927 12.2761 12.9426C12.5262 12.6926 12.6666 12.3534 12.6666 11.9998C12.6666 11.6462 12.5262 11.307 12.2761 11.057C12.0261 10.807 11.6869 10.6665 11.3333 10.6665C10.9797 10.6665 10.6405 10.807 10.3905 11.057C10.1405 11.307 9.99998 11.6462 9.99998 11.9998C9.99998 12.3534 10.1405 12.6926 10.3905 12.9426C10.6405 13.1927 10.9797 13.3331 11.3333 13.3331Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Copy = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.55556 5.2V2.8C5.55556 2.58783 5.64921 2.38434 5.81591 2.23431C5.9826 2.08429 6.2087 2 6.44444 2H17.1111C17.3469 2 17.573 2.08429 17.7397 2.23431C17.9064 2.38434 18 2.58783 18 2.8V14C18 14.2122 17.9064 14.4156 17.7397 14.5657C17.573 14.7157 17.3469 14.8 17.1111 14.8H14.4444V17.2C14.4444 17.6416 14.0444 18 13.5493 18H2.89511C2.77789 18.0006 2.66169 17.9804 2.55318 17.9405C2.44466 17.9006 2.34599 17.8418 2.26281 17.7674C2.17963 17.6931 2.11359 17.6047 2.06849 17.5073C2.02339 17.4099 2.00011 17.3055 2 17.2L2.00267 6C2.00267 5.5584 2.40267 5.2 2.89778 5.2H5.55556ZM3.78044 6.8L3.77778 16.4H12.6667V6.8H3.78044ZM7.33333 5.2H14.4444V13.2H16.2222V3.6H7.33333V5.2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Check = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M7.864 12.193L17.056 3L18.471 4.414L7.864 15.021L1.5 8.657L2.914 7.243L7.864 12.193Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Search = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.0258 13.8478L18.595 17.4162L17.4158 18.5953L13.8475 15.0262C12.5198 16.0905 10.8683 16.6694 9.16666 16.667C5.02666 16.667 1.66666 13.307 1.66666 9.16699C1.66666 5.02699 5.02666 1.66699 9.16666 1.66699C13.3067 1.66699 16.6667 5.02699 16.6667 9.16699C16.6691 10.8687 16.0902 12.5201 15.0258 13.8478ZM13.3542 13.2295C14.4118 12.1419 15.0024 10.684 15 9.16699C15 5.94366 12.3892 3.33366 9.16666 3.33366C5.94332 3.33366 3.33332 5.94366 3.33332 9.16699C3.33332 12.3895 5.94332 15.0003 9.16666 15.0003C10.6837 15.0027 12.1416 14.4121 13.2292 13.3545L13.3542 13.2295Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Close = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 18.3337C5.3975 18.3337 1.66666 14.6028 1.66666 10.0003C1.66666 5.39783 5.3975 1.66699 10 1.66699C14.6025 1.66699 18.3333 5.39783 18.3333 10.0003C18.3333 14.6028 14.6025 18.3337 10 18.3337ZM10 8.82199L7.64333 6.46449L6.46416 7.64366L8.82166 10.0003L6.46416 12.357L7.64333 13.5362L10 11.1787L12.3567 13.5362L13.5358 12.357L11.1783 10.0003L13.5358 7.64366L12.3567 6.46449L10 8.82199Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CloseX = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00042 6.17461L9.88792 3.28711L10.7128 4.11194L7.82525 6.99944L10.7128 9.88694L9.88792 10.7118L7.00042 7.82428L4.11292 10.7118L3.28809 9.88694L6.17559 6.99944L3.28809 4.11194L4.11292 3.28711L7.00042 6.17461Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ArrowDropDown = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path d="M12 15L7 10H17L12 15Z" fill="currentColor" />
    </svg>
  );
};
export const StockLine = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M6.66667 4.16699H9.16667V11.667H6.66667V14.167H5V11.667H2.5V4.16699H5V1.66699H6.66667V4.16699ZM4.16667 5.83366V10.0003H7.5V5.83366H4.16667ZM15 8.33366H17.5V15.8337H15V18.3337H13.3333V15.8337H10.8333V8.33366H13.3333V5.83366H15V8.33366ZM12.5 10.0003V14.167H15.8333V10.0003H12.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Qrcode = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M13.3333 14.1667V13.3333H10.8333V10.8333H13.3333V12.5H15V14.1667H14.1667V15.8333H12.5V17.5H10.8333V15H12.5V14.1667H13.3333ZM17.5 17.5H14.1667V15.8333H15.8333V14.1667H17.5V17.5ZM2.5 2.5H9.16667V9.16667H2.5V2.5ZM4.16667 4.16667V7.5H7.5V4.16667H4.16667ZM10.8333 2.5H17.5V9.16667H10.8333V2.5ZM12.5 4.16667V7.5H15.8333V4.16667H12.5ZM2.5 10.8333H9.16667V17.5H2.5V10.8333ZM4.16667 12.5V15.8333H7.5V12.5H4.16667ZM15 10.8333H17.5V12.5H15V10.8333ZM5 5H6.66667V6.66667H5V5ZM5 13.3333H6.66667V15H5V13.3333ZM13.3333 5H15V6.66667H13.3333V5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Scan = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M10 2H14V5.33333H12.6667V3.33333H10V2ZM6 2V3.33333H3.33333V5.33333H2V2H6ZM10 14V12.6667H12.6667V10.6667H14V14H10ZM6 14H2V10.6667H3.33333V12.6667H6V14ZM2 7.33333H14V8.66667H2V7.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Setting = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M2.21276 14.0598C1.92517 12.7015 1.92517 11.298 2.21276 9.93976C3.32276 10.0698 4.29276 9.70276 4.60876 8.93876C4.92576 8.17376 4.50076 7.22876 3.62276 6.53576C4.3798 5.37209 5.37209 4.3798 6.53576 3.62276C7.22776 4.49976 8.17376 4.92576 8.93876 4.60876C9.70376 4.29176 10.0708 3.32276 9.93976 2.21276C11.298 1.92517 12.7015 1.92517 14.0598 2.21276C13.9298 3.32276 14.2968 4.29276 15.0608 4.60876C15.8258 4.92576 16.7708 4.50076 17.4638 3.62276C18.6274 4.3798 19.6197 5.37209 20.3768 6.53576C19.4998 7.22776 19.0738 8.17376 19.3908 8.93876C19.7078 9.70376 20.6768 10.0708 21.7868 9.93976C22.0744 11.298 22.0744 12.7015 21.7868 14.0598C20.6768 13.9298 19.7068 14.2968 19.3908 15.0608C19.0738 15.8258 19.4988 16.7708 20.3768 17.4638C19.6197 18.6274 18.6274 19.6197 17.4638 20.3768C16.7718 19.4998 15.8258 19.0738 15.0608 19.3908C14.2958 19.7078 13.9288 20.6768 14.0598 21.7868C12.7015 22.0744 11.298 22.0744 9.93976 21.7868C10.0698 20.6768 9.70276 19.7068 8.93876 19.3908C8.17376 19.0738 7.22876 19.4988 6.53576 20.3768C5.37209 19.6197 4.3798 18.6274 3.62276 17.4638C4.49976 16.7718 4.92576 15.8258 4.60876 15.0608C4.29176 14.2958 3.32276 13.9288 2.21276 14.0598ZM3.99976 12.2098C5.09976 12.5148 6.00676 13.2118 6.45676 14.2958C6.90576 15.3808 6.75676 16.5158 6.19476 17.5078C6.29076 17.6098 6.38976 17.7088 6.49176 17.8048C7.48476 17.2428 8.61876 17.0948 9.70376 17.5428C10.7878 17.9928 11.4848 18.8998 11.7898 19.9998C11.9298 20.0038 12.0698 20.0038 12.2098 19.9998C12.5148 18.8998 13.2118 17.9928 14.2958 17.5428C15.3808 17.0938 16.5158 17.2428 17.5078 17.8048C17.6098 17.7088 17.7088 17.6098 17.8048 17.5078C17.2428 16.5148 17.0948 15.3808 17.5428 14.2958C17.9928 13.2118 18.8998 12.5148 19.9998 12.2098C20.0038 12.0698 20.0038 11.9298 19.9998 11.7898C18.8998 11.4848 17.9928 10.7878 17.5428 9.70376C17.0938 8.61876 17.2428 7.48376 17.8048 6.49176C17.7084 6.39016 17.6094 6.29112 17.5078 6.19476C16.5148 6.75676 15.3808 6.90476 14.2958 6.45676C13.2118 6.00676 12.5148 5.09976 12.2098 3.99976C12.0698 3.99606 11.9297 3.99606 11.7898 3.99976C11.4848 5.09976 10.7878 6.00676 9.70376 6.45676C8.61876 6.90576 7.48376 6.75676 6.49176 6.19476C6.38976 6.29076 6.29076 6.38976 6.19476 6.49176C6.75676 7.48476 6.90476 8.61876 6.45676 9.70376C6.00676 10.7878 5.09976 11.4848 3.99976 11.7898C3.99576 11.9298 3.99576 12.0698 3.99976 12.2098ZM11.9998 14.9998C11.2041 14.9998 10.4411 14.6837 9.87844 14.1211C9.31583 13.5585 8.99976 12.7954 8.99976 11.9998C8.99976 11.2041 9.31583 10.4411 9.87844 9.87844C10.4411 9.31583 11.2041 8.99976 11.9998 8.99976C12.7954 8.99976 13.5585 9.31583 14.1211 9.87844C14.6837 10.4411 14.9998 11.2041 14.9998 11.9998C14.9998 12.7954 14.6837 13.5585 14.1211 14.1211C13.5585 14.6837 12.7954 14.9998 11.9998 14.9998ZM11.9998 12.9998C12.265 12.9998 12.5193 12.8944 12.7069 12.7069C12.8944 12.5193 12.9998 12.265 12.9998 11.9998C12.9998 11.7345 12.8944 11.4802 12.7069 11.2927C12.5193 11.1051 12.265 10.9998 11.9998 10.9998C11.7345 10.9998 11.4802 11.1051 11.2927 11.2927C11.1051 11.4802 10.9998 11.7345 10.9998 11.9998C10.9998 12.265 11.1051 12.5193 11.2927 12.7069C11.4802 12.8944 11.7345 12.9998 11.9998 12.9998Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SettingTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0L19.5 5.5V16.5L10 22L0.5 16.5V5.5L10 0ZM10 2.311L2.5 6.653V15.347L10 19.689L17.5 15.347V6.653L10 2.311ZM10 15C8.93913 15 7.92172 14.5786 7.17157 13.8284C6.42143 13.0783 6 12.0609 6 11C6 9.93913 6.42143 8.92172 7.17157 8.17157C7.92172 7.42143 8.93913 7 10 7C11.0609 7 12.0783 7.42143 12.8284 8.17157C13.5786 8.92172 14 9.93913 14 11C14 12.0609 13.5786 13.0783 12.8284 13.8284C12.0783 14.5786 11.0609 15 10 15ZM10 13C10.5304 13 11.0391 12.7893 11.4142 12.4142C11.7893 12.0391 12 11.5304 12 11C12 10.4696 11.7893 9.96086 11.4142 9.58579C11.0391 9.21071 10.5304 9 10 9C9.46957 9 8.96086 9.21071 8.58579 9.58579C8.21071 9.96086 8 10.4696 8 11C8 11.5304 8.21071 12.0391 8.58579 12.4142C8.96086 12.7893 9.46957 13 10 13Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Gifts = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M19.3597 6.34959H18.7629C19.0658 5.80709 19.1978 5.29 19.1558 4.80777C19.1198 4.40487 18.9399 3.83066 18.2801 3.37381C17.7314 2.99313 17.0296 2.90114 16.247 3.10735C14.9815 3.44361 13.4821 4.59841 12.4955 5.99744C11.5089 4.60156 10.0125 3.44361 8.74703 3.10735C7.96436 2.90114 7.26266 2.99311 6.71389 3.37381C6.05415 3.83066 5.87422 4.40805 5.83825 4.80777C5.79626 5.28681 5.92821 5.80709 6.23107 6.34959H5.64034C4.7377 6.34959 4 7.13001 4 8.08491V10.3215C4 11.0797 4.47081 11.7491 5.15452 11.9712C5.08854 12.1615 5.05555 12.3582 5.05555 12.5581V19.2647C5.05555 20.2195 5.79325 21 6.69589 21H18.3071C19.2097 21 19.9474 20.2196 19.9474 19.2647V12.5581C19.9474 12.3582 19.9144 12.1615 19.8485 11.9712C20.5292 11.7459 21 11.0765 21 10.3215V8.08491C21 7.12683 20.2653 6.34961 19.3597 6.34961V6.34959ZM18.3071 19.7627H13.0833V12.0568H18.3041C18.565 12.0568 18.7749 12.2821 18.7749 12.5581V19.2647C18.7779 19.5407 18.565 19.7627 18.3071 19.7627ZM13.728 6.34959C14.5587 5.33757 15.6502 4.53813 16.5349 4.30336C16.9937 4.1828 17.3715 4.21452 17.6444 4.40487C17.9353 4.60475 17.9862 4.78558 17.9982 4.92199C18.0432 5.42007 17.5394 6.08946 17.3025 6.34959H13.728ZM19.8305 8.08491V10.3215C19.8306 10.387 19.8186 10.4518 19.795 10.5123C19.7713 10.5728 19.7367 10.6278 19.6929 10.6741C19.6492 10.7203 19.5972 10.757 19.54 10.782C19.4828 10.807 19.4216 10.8197 19.3597 10.8196H13.0833V7.58688H19.3597C19.4215 7.58672 19.4828 7.59949 19.54 7.62447C19.5972 7.64944 19.6492 7.68612 19.6929 7.7324C19.7367 7.77868 19.7713 7.83365 19.795 7.89415C19.8186 7.95465 19.8306 8.01948 19.8305 8.08494V8.08491ZM11.9167 12.0568V19.7628H6.69589C6.43499 19.7628 6.22508 19.5375 6.22508 19.2647V12.5581C6.22508 12.2821 6.43499 12.0568 6.69589 12.0568L11.9167 12.0568ZM7.00775 4.92199C7.01976 4.78558 7.07074 4.6079 7.35861 4.40487C7.62851 4.21452 8.00635 4.17962 8.46816 4.30336C9.34982 4.5381 10.4383 5.33441 11.269 6.34959H7.70045C7.48756 6.12118 6.95977 5.42957 7.00775 4.92199ZM5.16652 8.08491C5.16652 7.80893 5.37643 7.58367 5.63733 7.58367H11.9137V10.8164H5.64032C5.37942 10.8164 5.16951 10.5912 5.16951 10.3183V8.08491"
        fill="currentColor"
      />
    </svg>
  );
};

export const GiftThree = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 6.1847e-06C14.7023 -7.73774e-05 15.3922 0.184738 16.0004 0.53587C16.6086 0.887002 17.1137 1.39207 17.4647 2.0003C17.8158 2.60853 18.0006 3.29847 18.0005 4.00075C18.0003 4.70304 17.8153 5.39291 17.464 6.00101L22 6.00001V8.00001H20V18C20 18.2652 19.8946 18.5196 19.7071 18.7071C19.5196 18.8946 19.2652 19 19 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V8.00001H0V6.00001L4.536 6.00101C4.03986 5.14189 3.88069 4.12906 4.08938 3.15918C4.29808 2.1893 4.85975 1.33157 5.66533 0.752558C6.47092 0.173543 7.46293 -0.0854441 8.44875 0.0258849C9.43456 0.137214 10.3438 0.610914 11 1.35501C11.3746 0.928388 11.8361 0.58678 12.3535 0.353084C12.8709 0.119389 13.4323 -0.000994248 14 6.1847e-06ZM10 8.00001H4V17H10V8.00001ZM18 8.00001H12V17H18V8.00001ZM8 2.00001C7.48102 1.99768 6.98145 2.19719 6.60685 2.55639C6.23224 2.91558 6.01193 3.40632 5.99246 3.92495C5.97299 4.44357 6.15588 4.94945 6.50249 5.33572C6.84911 5.722 7.3323 5.9584 7.85 5.99501L8 6.00001H10V4.00001C10 3.52207 9.82889 3.05992 9.51759 2.69726C9.2063 2.33461 8.77542 2.09541 8.303 2.02301L8.149 2.00501L8 2.00001ZM14 2.00001C13.4954 1.99985 13.0094 2.19041 12.6395 2.5335C12.2695 2.87659 12.0428 3.34685 12.005 3.85001L12 4.00001V6.00001H14C14.5046 6.00017 14.9906 5.8096 15.3605 5.46651C15.7305 5.12342 15.9572 4.65316 15.995 4.15001L16 4.00001C16 3.46957 15.7893 2.96087 15.4142 2.58579C15.0391 2.21072 14.5304 2.00001 14 2.00001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Points = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <rect
        x="1"
        y="1"
        width="20"
        height="20"
        rx="10"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5909 7.38612L10.9016 5.5L11.0984 5.5L11.4091 7.38612C11.68 9.0309 12.9691 10.32 14.6139 10.5909L16.5 10.9016V11.0984L14.6139 11.4091C12.9691 11.68 11.68 12.9691 11.4091 14.6139L11.0984 16.5H10.9016L10.5909 14.6139C10.32 12.9691 9.0309 11.68 7.38612 11.4091L5.5 11.0984L5.5 10.9016L7.38612 10.5909C9.0309 10.32 10.32 9.0309 10.5909 7.38612Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Box = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M19.9781 2.52783C18.4688 1.80274 16.0125 1.82774 14.5156 2.58409L6.67188 6.54398C5.175 7.30033 5.1875 8.50362 6.69688 9.22246L15.0875 13.2167C16.5969 13.9356 19.0688 13.9356 20.5781 13.2136L28.6875 9.34123C30.1969 8.61926 30.1969 7.43785 28.6906 6.71276L19.9781 2.52783ZM14.2719 14.6075L6.73125 11.1508C5.22812 10.4632 4 11.3946 4 13.2261V20.9459C4 22.7774 5.20312 24.9058 6.67188 25.6809L14.3313 29.7158C15.8 30.4909 17.0031 29.6251 17.0031 27.7937V19.1956C17 17.3642 15.7719 15.2983 14.2719 14.6075ZM10.5 19.0956L9.92812 18.7956C8.44063 18.0142 7.23438 16.8203 7.24375 16.139C7.25313 15.4577 8.47813 15.5389 9.9625 16.3203L10.5344 16.6203C12.0219 17.4017 13.2281 18.5956 13.2188 19.2769C13.2063 19.9582 11.9875 19.8739 10.5 19.0956ZM21.7125 14.5482C20.2188 15.267 19 17.3548 19 19.1863V27.7499C19 29.5814 20.1906 30.419 21.6469 29.6126L29.3531 25.3465C30.8094 24.5401 32 22.3804 32 20.5489V12.9136C32 11.0821 30.7812 10.1726 29.2875 10.8914L21.7125 14.5482Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const User = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 22C4 19.8783 4.84285 17.8434 6.34315 16.3431C7.84344 14.8429 9.87827 14 12 14C14.1217 14 16.1566 14.8429 17.6569 16.3431C19.1571 17.8434 20 19.8783 20 22H18C18 20.4087 17.3679 18.8826 16.2426 17.7574C15.1174 16.6321 13.5913 16 12 16C10.4087 16 8.88258 16.6321 7.75736 17.7574C6.63214 18.8826 6 20.4087 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Plus = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.16675 9.16602V4.16602H10.8334V9.16602H15.8334V10.8327H10.8334V15.8327H9.16675V10.8327H4.16675V9.16602H9.16675Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Info = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0003 18.3337C5.39783 18.3337 1.66699 14.6028 1.66699 10.0003C1.66699 5.39783 5.39783 1.66699 10.0003 1.66699C14.6028 1.66699 18.3337 5.39783 18.3337 10.0003C18.3337 14.6028 14.6028 18.3337 10.0003 18.3337ZM10.0003 16.667C11.7684 16.667 13.4641 15.9646 14.7144 14.7144C15.9646 13.4641 16.667 11.7684 16.667 10.0003C16.667 8.23222 15.9646 6.53652 14.7144 5.28628C13.4641 4.03604 11.7684 3.33366 10.0003 3.33366C8.23222 3.33366 6.53652 4.03604 5.28628 5.28628C4.03604 6.53652 3.33366 8.23222 3.33366 10.0003C3.33366 11.7684 4.03604 13.4641 5.28628 14.7144C6.53652 15.9646 8.23222 16.667 10.0003 16.667ZM9.16699 12.5003H10.8337V14.167H9.16699V12.5003ZM9.16699 5.83366H10.8337V10.8337H9.16699V5.83366Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const InfoTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7.00001 -0.000488281C8.85666 -0.000488281 10.6373 0.737062 11.9501 2.04991C13.263 3.36276 14.0005 5.14336 14.0005 7.00001C14.0005 8.85666 13.263 10.6373 11.9501 11.9501C10.6373 13.263 8.85666 14.0005 7.00001 14.0005C5.14336 14.0005 3.36276 13.263 2.04991 11.9501C0.737062 10.6373 -0.000488281 8.85666 -0.000488281 7.00001C-0.000488281 5.14336 0.737062 3.36276 2.04991 2.04991C3.36276 0.737062 5.14336 -0.000488281 7.00001 -0.000488281ZM8.05001 4.29751C8.57001 4.29751 8.99201 3.93651 8.99201 3.40151C8.99201 2.86651 8.56901 2.50551 8.05001 2.50551C7.53001 2.50551 7.11001 2.86651 7.11001 3.40151C7.11001 3.93651 7.53001 4.29751 8.05001 4.29751ZM8.23301 9.92451C8.23301 9.81751 8.27001 9.53951 8.24901 9.38151L7.42701 10.3275C7.25701 10.5065 7.04401 10.6305 6.94401 10.5975C6.89864 10.5808 6.86072 10.5485 6.83707 10.5063C6.81342 10.4642 6.8056 10.4149 6.81501 10.3675L8.18501 6.03951C8.29701 5.49051 7.98901 4.98951 7.33601 4.92551C6.64701 4.92551 5.63301 5.62451 5.01601 6.51151C5.01601 6.61751 4.99601 6.88151 5.01701 7.03951L5.83801 6.09251C6.00801 5.91551 6.20601 5.79051 6.30601 5.82451C6.35528 5.8422 6.39565 5.87849 6.41846 5.9256C6.44127 5.97272 6.4447 6.0269 6.42801 6.07651L5.07001 10.3835C4.91301 10.8875 5.21001 11.3815 5.93001 11.4935C6.99001 11.4935 7.61601 10.8115 8.23401 9.92451H8.23301Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Pending = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M8.99984 17.3346C4.39734 17.3346 0.666504 13.6038 0.666504 9.0013C0.666504 4.3988 4.39734 0.667969 8.99984 0.667969C13.6023 0.667969 17.3332 4.3988 17.3332 9.0013C17.3332 13.6038 13.6023 17.3346 8.99984 17.3346ZM8.99984 15.668C10.7679 15.668 12.4636 14.9656 13.7139 13.7153C14.9641 12.4651 15.6665 10.7694 15.6665 9.0013C15.6665 7.23319 14.9641 5.5375 13.7139 4.28726C12.4636 3.03701 10.7679 2.33464 8.99984 2.33464C7.23173 2.33464 5.53603 3.03701 4.28579 4.28726C3.03555 5.5375 2.33317 7.23319 2.33317 9.0013C2.33317 10.7694 3.03555 12.4651 4.28579 13.7153C5.53603 14.9656 7.23173 15.668 8.99984 15.668V15.668ZM9.83317 9.0013H13.1665V10.668H8.1665V4.83464H9.83317V9.0013Z"
        fill="#F48E2F"
      />
    </svg>
  );
};
export const Complete = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99984 18.3346C5.39734 18.3346 1.6665 14.6038 1.6665 10.0013C1.6665 5.3988 5.39734 1.66797 9.99984 1.66797C14.6023 1.66797 18.3332 5.3988 18.3332 10.0013C18.3332 14.6038 14.6023 18.3346 9.99984 18.3346ZM9.169 13.3346L15.0607 7.44214L13.8823 6.2638L9.169 10.978L6.8115 8.62047L5.63317 9.7988L9.169 13.3346Z"
        fill="#26BD6C"
      />
    </svg>
  );
};
export const Cancelled = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10.0001 18.3333C5.39758 18.3333 1.66675 14.6025 1.66675 9.99996C1.66675 5.39746 5.39758 1.66663 10.0001 1.66663C14.6026 1.66663 18.3334 5.39746 18.3334 9.99996C18.3334 14.6025 14.6026 18.3333 10.0001 18.3333ZM10.0001 16.6666C11.7682 16.6666 13.4639 15.9642 14.7141 14.714C15.9644 13.4638 16.6667 11.7681 16.6667 9.99996C16.6667 8.23185 15.9644 6.53616 14.7141 5.28591C13.4639 4.03567 11.7682 3.33329 10.0001 3.33329C8.23197 3.33329 6.53628 4.03567 5.28604 5.28591C4.03579 6.53616 3.33341 8.23185 3.33341 9.99996C3.33341 11.7681 4.03579 13.4638 5.28604 14.714C6.53628 15.9642 8.23197 16.6666 10.0001 16.6666ZM10.0001 8.82163L12.3567 6.46413L13.5359 7.64329L11.1784 9.99996L13.5359 12.3566L12.3567 13.5358L10.0001 11.1783L7.64341 13.5358L6.46425 12.3566L8.82175 9.99996L6.46425 7.64329L7.64341 6.46413L10.0001 8.82163Z"
        fill="#E6483D"
      />
    </svg>
  );
};
export const Link = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.79495 6.08267L10.8562 7.14392C11.3438 7.63144 11.7305 8.21022 11.9944 8.84721C12.2583 9.48421 12.3941 10.1669 12.3941 10.8564C12.3941 11.5459 12.2583 12.2286 11.9944 12.8656C11.7305 13.5026 11.3438 14.0814 10.8562 14.5689L10.5907 14.8337C9.60608 15.8183 8.27066 16.3714 6.8782 16.3714C5.48574 16.3714 4.15031 15.8183 3.1657 14.8337C2.18108 13.8491 1.62793 12.5136 1.62793 11.1212C1.62793 9.72872 2.18108 8.39329 3.1657 7.40867L4.22695 8.46992C3.87622 8.81759 3.59763 9.2311 3.40714 9.68673C3.21666 10.1424 3.11805 10.6311 3.11697 11.125C3.11589 11.6188 3.21236 12.108 3.40084 12.5644C3.58933 13.0209 3.86611 13.4356 4.21531 13.7848C4.56451 14.134 4.97924 14.4108 5.43569 14.5993C5.89214 14.7878 6.38133 14.8842 6.87517 14.8832C7.36901 14.8821 7.85777 14.7835 8.31339 14.593C8.76902 14.4025 9.18253 14.1239 9.5302 13.7732L9.7957 13.5077C10.4987 12.8044 10.8936 11.8508 10.8936 10.8564C10.8936 9.86206 10.4987 8.9084 9.7957 8.20517L8.73445 7.14392L9.7957 6.08342L9.79495 6.08267ZM14.8334 10.5909L13.7729 9.53042C14.1237 9.18276 14.4023 8.76925 14.5927 8.31362C14.7832 7.858 14.8818 7.36924 14.8829 6.8754C14.884 6.38156 14.7875 5.89237 14.5991 5.43592C14.4106 4.97946 14.1338 4.56473 13.7846 4.21554C13.4354 3.86634 13.0207 3.58955 12.5642 3.40107C12.1077 3.21258 11.6186 3.11611 11.1247 3.1172C10.6309 3.11828 10.1421 3.21689 9.6865 3.40737C9.23088 3.59785 8.81736 3.87645 8.4697 4.22717L8.2042 4.49267C7.50118 5.1959 7.10625 6.14956 7.10625 7.14392C7.10625 8.13829 7.50118 9.09195 8.2042 9.79517L9.26545 10.8564L8.2042 11.9169L7.1437 10.8564C6.65613 10.3689 6.26937 9.79013 6.0055 9.15314C5.74163 8.51614 5.60582 7.83341 5.60582 7.14392C5.60582 6.45444 5.74163 5.77171 6.0055 5.13471C6.26937 4.49772 6.65613 3.91894 7.1437 3.43142L7.4092 3.16667C8.39381 2.18206 9.72924 1.62891 11.1217 1.62891C12.5142 1.62891 13.8496 2.18206 14.8342 3.16667C15.8188 4.15129 16.372 5.48672 16.372 6.87917C16.372 8.27163 15.8188 9.60706 14.8342 10.5917L14.8334 10.5909Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Change = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M4 10.0016V10.9676C4.00008 11.0151 3.98659 11.0617 3.96113 11.1018C3.93567 11.142 3.89929 11.1741 3.85625 11.1943C3.81321 11.2145 3.7653 11.222 3.71814 11.2159C3.67099 11.2099 3.62653 11.1905 3.59 11.1601L1.53 9.44356C1.49049 9.41061 1.46211 9.36628 1.44872 9.31661C1.43534 9.26693 1.4376 9.21434 1.45521 9.166C1.47282 9.11766 1.50491 9.07593 1.54711 9.0465C1.5893 9.01707 1.63955 9.00138 1.691 9.00156H9C9.26522 9.00156 9.51957 8.89621 9.70711 8.70867C9.89464 8.52113 10 8.26678 10 8.00156V4.00156H11V8.00156C11 8.532 10.7893 9.0407 10.4142 9.41578C10.0391 9.79085 9.53043 10.0016 9 10.0016H4ZM8 2.00156V1.03556C7.99992 0.988017 8.0134 0.941435 8.03887 0.90128C8.06433 0.861126 8.10071 0.829065 8.14375 0.808858C8.18679 0.788651 8.2347 0.781136 8.28186 0.787194C8.32901 0.793253 8.37347 0.812633 8.41 0.843063L10.47 2.55956C10.5095 2.59248 10.5378 2.63677 10.5512 2.6864C10.5646 2.73603 10.5624 2.78858 10.5449 2.83689C10.5273 2.88521 10.4953 2.92694 10.4532 2.95641C10.4111 2.98588 10.3609 3.00164 10.3095 3.00156H3C2.73478 3.00156 2.48043 3.10692 2.29289 3.29446C2.10536 3.48199 2 3.73635 2 4.00156V8.00156H1V4.00156C1 3.47113 1.21071 2.96242 1.58579 2.58735C1.96086 2.21228 2.46957 2.00156 3 2.00156H8Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Refresh = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M2.7315 2.2165C3.63878 1.43034 4.79949 0.99833 6 1C8.7615 1 11 3.2385 11 6C11 7.068 10.665 8.058 10.095 8.87L8.5 6H10C10.0001 5.21582 9.76962 4.44891 9.33733 3.79463C8.90504 3.14036 8.28997 2.62758 7.56859 2.32007C6.84721 2.01255 6.05136 1.92386 5.27998 2.06501C4.5086 2.20617 3.79573 2.57095 3.23 3.114L2.7315 2.2165ZM9.2685 9.7835C8.36122 10.5697 7.20051 11.0017 6 11C3.2385 11 1 8.7615 1 6C1 4.932 1.335 3.942 1.905 3.13L3.5 6H2C1.99994 6.78419 2.23038 7.5511 2.66267 8.20538C3.09496 8.85965 3.71003 9.37243 4.43141 9.67994C5.15279 9.98746 5.94864 10.0762 6.72002 9.935C7.4914 9.79384 8.20427 9.42905 8.77 8.886L9.2685 9.7835Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CollectionActive = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M10 0L13.2328 5.55041L19.5106 6.90983L15.2308 11.6996L15.8779 18.0902L10 15.5L4.12215 18.0902L4.76919 11.6996L0.489435 6.90983L6.76718 5.55041L10 0Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CollectionInActive = ({
  className,
}: {
  className?: string;
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
    >
      <path
        d="M10 1.2418L12.6927 5.86497L12.8314 6.10296L13.1005 6.16125L18.3295 7.29357L14.7648 11.2832L14.5812 11.4885L14.609 11.7626L15.1479 17.0855L10.252 14.9281L10 14.817L9.74797 14.9281L4.85206 17.0855L5.39101 11.7626L5.41875 11.4885L5.23525 11.2832L1.67046 7.29357L6.89946 6.16125L7.16863 6.10296L7.30725 5.86497L10 1.2418Z"
        stroke="currentColor"
        strokeWidth="1.25"
      />
    </svg>
  );
};

export const EyeOpen = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.99978 2C11.5944 2 14.5851 4.58667 15.2124 8C14.5858 11.4133 11.5944 14 7.99978 14C4.40511 14 1.41444 11.4133 0.787109 8C1.41378 4.58667 4.40511 2 7.99978 2ZM7.99978 12.6667C9.35942 12.6664 10.6787 12.2045 11.7417 11.3568C12.8047 10.509 13.5484 9.32552 13.8511 8C13.5473 6.67554 12.8031 5.49334 11.7402 4.64668C10.6773 3.80003 9.35865 3.33902 7.99978 3.33902C6.64091 3.33902 5.32224 3.80003 4.25936 4.64668C3.19648 5.49334 2.45229 6.67554 2.14844 8C2.45117 9.32552 3.19489 10.509 4.25787 11.3568C5.32085 12.2045 6.64013 12.6664 7.99978 12.6667ZM7.99978 11C7.20413 11 6.44107 10.6839 5.87846 10.1213C5.31585 9.55871 4.99978 8.79565 4.99978 8C4.99978 7.20435 5.31585 6.44129 5.87846 5.87868C6.44107 5.31607 7.20413 5 7.99978 5C8.79543 5 9.55849 5.31607 10.1211 5.87868C10.6837 6.44129 10.9998 7.20435 10.9998 8C10.9998 8.79565 10.6837 9.55871 10.1211 10.1213C9.55849 10.6839 8.79543 11 7.99978 11ZM7.99978 9.66667C8.4418 9.66667 8.86573 9.49107 9.17829 9.17851C9.49085 8.86595 9.66644 8.44203 9.66644 8C9.66644 7.55797 9.49085 7.13405 9.17829 6.82149C8.86573 6.50893 8.4418 6.33333 7.99978 6.33333C7.55775 6.33333 7.13383 6.50893 6.82127 6.82149C6.5087 7.13405 6.33311 7.55797 6.33311 8C6.33311 8.44203 6.5087 8.86595 6.82127 9.17851C7.13383 9.49107 7.55775 9.66667 7.99978 9.66667Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EyeClose = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        d="M11.9211 12.8643C10.7486 13.608 9.38826 14.0019 7.99978 13.9997C4.40511 13.9997 1.41444 11.413 0.787109 7.99968C1.0738 6.44682 1.85486 5.02828 3.01378 3.95568L0.927776 1.87168L1.87111 0.928345L15.0704 14.1283L14.1271 15.071L11.9204 12.8643H11.9211ZM3.95644 4.89968C3.05045 5.7234 2.41932 6.80553 2.14844 7.99968C2.35664 8.91065 2.77462 9.76044 3.36911 10.4814C3.9636 11.2024 4.71819 11.7746 5.57281 12.1525C6.42743 12.5305 7.35847 12.7037 8.29184 12.6584C9.2252 12.6131 10.1351 12.3506 10.9491 11.8917L9.59711 10.5397C9.02157 10.9022 8.33991 11.0584 7.66393 10.9826C6.98796 10.9069 6.3578 10.6036 5.87682 10.1226C5.39584 9.64165 5.09259 9.01149 5.01682 8.33552C4.94104 7.65954 5.09723 6.97788 5.45978 6.40234L3.95644 4.89968ZM8.60911 9.55168L6.44778 7.39035C6.32915 7.6923 6.30123 8.02231 6.36745 8.33991C6.43366 8.6575 6.59112 8.94886 6.82052 9.17827C7.04992 9.40767 7.34129 9.56513 7.65888 9.63134C7.97647 9.69755 8.30649 9.66963 8.60844 9.55101L8.60911 9.55168ZM13.8711 11.061L12.9171 10.1077C13.3628 9.47255 13.68 8.75647 13.8511 7.99968C13.6699 7.20616 13.3293 6.45778 12.8499 5.80001C12.3705 5.14224 11.7623 4.58883 11.0624 4.17341C10.3624 3.758 9.5853 3.48926 8.77826 3.38352C7.97122 3.27778 7.15111 3.33726 6.36778 3.55834L5.31578 2.50634C6.14711 2.17968 7.05311 1.99968 7.99978 1.99968C11.5944 1.99968 14.5851 4.58634 15.2124 7.99968C15.0082 9.11014 14.549 10.1581 13.8711 11.061ZM7.81511 5.00501C8.23945 4.97879 8.66452 5.04306 9.06214 5.19356C9.45976 5.34406 9.82085 5.57735 10.1215 5.87798C10.4221 6.1786 10.6554 6.5397 10.8059 6.93732C10.9564 7.33494 11.0207 7.76 10.9944 8.18434L7.81444 5.00501H7.81511Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HideBalance = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="85"
      height="36"
      viewBox="0 0 85 36"
      fill="none"
    >
      <path
        d="M73.944 25.48L70.904 23.72L73.784 19.32L68.584 19.6V16.12L73.824 16.44L70.944 12L73.984 10.24L76.424 15.28L78.824 10.24L81.864 12.04L78.984 16.44L84.224 16.12V19.6L78.984 19.32L81.864 23.72L78.824 25.48L76.384 20.4L73.944 25.48Z"
        fill="currentColor"
      />
      <path
        d="M56.858 25.48L53.818 23.72L56.698 19.32L51.498 19.6V16.12L56.738 16.44L53.858 12L56.898 10.24L59.338 15.28L61.738 10.24L64.778 12.04L61.898 16.44L67.138 16.12V19.6L61.898 19.32L64.778 23.72L61.738 25.48L59.298 20.4L56.858 25.48Z"
        fill="currentColor"
      />
      <path
        d="M39.7721 25.48L36.7321 23.72L39.6121 19.32L34.4121 19.6V16.12L39.6521 16.44L36.7721 12L39.8121 10.24L42.2521 15.28L44.6521 10.24L47.6921 12.04L44.8121 16.44L50.0521 16.12V19.6L44.8121 19.32L47.6921 23.72L44.6521 25.48L42.2121 20.4L39.7721 25.48Z"
        fill="currentColor"
      />
      <path
        d="M22.6862 25.48L19.6462 23.72L22.5262 19.32L17.3262 19.6V16.12L22.5662 16.44L19.6862 12L22.7262 10.24L25.1662 15.28L27.5662 10.24L30.6062 12.04L27.7262 16.44L32.9662 16.12V19.6L27.7262 19.32L30.6062 23.72L27.5662 25.48L25.1262 20.4L22.6862 25.48Z"
        fill="currentColor"
      />
      <path
        d="M5.60023 25.48L2.56023 23.72L5.44024 19.32L0.240234 19.6V16.12L5.48023 16.44L2.60023 12L5.64023 10.24L8.08024 15.28L10.4802 10.24L13.5202 12.04L10.6402 16.44L15.8802 16.12V19.6L10.6402 19.32L13.5202 23.72L10.4802 25.48L8.04024 20.4L5.60023 25.48Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Timer = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.6181 5.968L19.0711 4.515L20.4851 5.929L19.0321 7.382C20.4678 9.17917 21.161 11.4579 20.9691 13.7501C20.7773 16.0424 19.7151 18.1742 18.0005 19.7077C16.286 21.2412 14.0494 22.0601 11.75 21.9961C9.45067 21.9321 7.26307 20.9901 5.63653 19.3635C4.00999 17.737 3.06799 15.5494 3.00398 13.25C2.93997 10.9506 3.75881 8.71402 5.29234 6.99951C6.82587 5.285 8.95767 4.22275 11.2499 4.03092C13.5422 3.83909 15.8209 4.53223 17.6181 5.968ZM12.0001 20C12.9193 20 13.8296 19.8189 14.6788 19.4672C15.5281 19.1154 16.2998 18.5998 16.9498 17.9497C17.5998 17.2997 18.1154 16.5281 18.4672 15.6788C18.819 14.8295 19.0001 13.9193 19.0001 13C19.0001 12.0807 18.819 11.1705 18.4672 10.3212C18.1154 9.47194 17.5998 8.70026 16.9498 8.05025C16.2998 7.40024 15.5281 6.88463 14.6788 6.53284C13.8296 6.18106 12.9193 6 12.0001 6C10.1435 6 8.36307 6.7375 7.05031 8.05025C5.73756 9.36301 5.00006 11.1435 5.00006 13C5.00006 14.8565 5.73756 16.637 7.05031 17.9497C8.36307 19.2625 10.1435 20 12.0001 20ZM11.0001 8H13.0001V14H11.0001V8ZM8.00006 1H16.0001V3H8.00006V1Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const More = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M5.53638 10C4.43638 10 3.53638 10.9 3.53638 12C3.53638 13.1 4.43638 14 5.53638 14C6.63638 14 7.53638 13.1 7.53638 12C7.53638 10.9 6.63638 10 5.53638 10ZM19.5364 10C18.4364 10 17.5364 10.9 17.5364 12C17.5364 13.1 18.4364 14 19.5364 14C20.6364 14 21.5364 13.1 21.5364 12C21.5364 10.9 20.6364 10 19.5364 10ZM12.5364 10C11.4364 10 10.5364 10.9 10.5364 12C10.5364 13.1 11.4364 14 12.5364 14C13.6364 14 14.5364 13.1 14.5364 12C14.5364 10.9 13.6364 10 12.5364 10Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const MoreTwo = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const List = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H17C17.2652 0 17.5196 0.105357 17.7071 0.292893C17.8946 0.48043 18 0.734784 18 1V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20ZM16 18V2H2V18H16ZM5 7H13V9H5V7ZM5 11H13V13H5V11Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UserGroup = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M11.4 34.9998C9.15979 34.9998 8.03968 34.9998 7.18404 34.5639C6.43139 34.1804 5.81947 33.5684 5.43597 32.8158C5 31.9602 5 30.84 5 28.5998V11.4C5 9.15972 5 8.03958 5.43598 7.18393C5.81948 6.43127 6.43141 5.81936 7.18407 5.43587C8.03973 4.9999 9.15976 4.99991 11.3998 4.99994C16.3058 4.99999 23.1391 5.00003 28.6039 4.99987C30.8415 4.99981 31.9602 4.99977 32.8159 5.43574C33.5686 5.81924 34.1805 6.43111 34.564 7.18381C35 8.03947 35 9.15971 35 11.4002V28.5998C35 30.84 35 31.9602 34.564 32.8158C34.1805 33.5684 33.5686 34.1804 32.816 34.5639C31.9603 34.9998 30.8402 34.9998 28.6 34.9998H11.4Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 15H8.33329"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66663 25H8.33329"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 18.3332C21.8409 18.3332 23.3333 16.8408 23.3333 14.9998C23.3333 13.1589 21.8409 11.6665 20 11.6665C18.159 11.6665 16.6666 13.1589 16.6666 14.9998C16.6666 16.8408 18.159 18.3332 20 18.3332Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1666 28.3332V27.4998C14.1666 25.9165 14.8333 24.4165 15.8333 23.3332C16.9166 22.2498 18.3333 21.6665 20 21.6665C23.25 21.6665 25.8333 24.2498 25.8333 27.4998V28.3332"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ExternalWallet = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M11.4 11.6673C9.16008 11.667 8.04012 11.6669 7.18436 12.1028C6.43168 12.4862 5.81957 13.0983 5.43604 13.8509C5 14.7066 5 15.8267 5 18.0668V28.6001C5 30.8404 5 31.9605 5.43597 32.8161C5.81947 33.5688 6.43139 34.1807 7.18404 34.5642C8.03968 35.0002 9.15979 35.0002 11.4 35.0002C17.1333 35.0002 22.8667 35.0002 28.6 35.0002C30.8402 35.0002 31.9603 35.0002 32.816 34.5642C33.5686 34.1807 34.1805 33.5688 34.564 32.8161C35 31.9605 35 30.8404 35 28.6002V18.0693C35 15.8278 35 14.7071 34.5639 13.8513C34.1802 13.0984 33.5684 12.4868 32.8154 12.1032C31.9596 11.6673 30.8385 11.6676 28.5962 11.668C22.8641 11.6692 17.1321 11.668 11.4 11.6673Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35 26.6667H26.6C26.0399 26.6667 25.7598 26.6667 25.5459 26.5577C25.3578 26.4618 25.2048 26.3088 25.1089 26.1206C24.9999 25.9067 24.9999 25.6267 25 25.0666L25.0002 21.5999C25.0002 21.0399 25.0002 20.7599 25.1092 20.546C25.2051 20.3578 25.3581 20.2049 25.5462 20.109C25.7601 20 26.0401 20 26.6002 20L35 20V26.6667Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27 11.5L21.3609 6.2637C20.5935 5.55114 19.4065 5.55114 18.6391 6.26369L13 11.5"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export const Lightning = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <g clipPath="url(#clip0_372_65554)">
        <path
          d="M10.8333 7.60596H17.4999L9.16658 20.106V12.606H3.33325L10.8333 0.105957V7.60596ZM9.16658 9.27262V6.12262L6.27659 10.9393H10.8333V14.601L14.3858 9.27262H9.16658Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_372_65554">
          <rect
            width="20"
            height="20"
            fill="currentColor"
            transform="translate(0 0.105957)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Bitbot = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="154"
      height="25"
      viewBox="0 0 154 25"
      fill="none"
    >
      <path
        d="M0 24.3818V0H18.5816C23.4788 0 25.8753 2.63963 25.8753 6.70326C25.8753 9.44708 24.6249 11.3573 22.5758 12.1214C24.8681 12.8161 26.1531 14.7263 26.1531 17.5396C26.1531 21.5685 23.6177 24.3818 18.4774 24.3818H0ZM6.32121 18.79H17.6785C19.2068 18.79 19.7972 18.0259 19.7972 16.7755C19.7972 15.5599 19.2068 14.7958 17.6785 14.7958H6.32121V18.79ZM6.32121 9.55128H17.4354C18.9636 9.55128 19.5541 8.78718 19.5541 7.57156C19.5541 6.32121 18.9636 5.59184 17.4354 5.59184H6.32121V9.55128Z"
        fill="currentColor"
      />
      <path
        d="M29.7121 24.3818V0H36.3111V24.3818H29.7121Z"
        fill="currentColor"
      />
      <path
        d="M49.3465 24.3818V5.93916H39.3437V0H65.9831V5.93916H56.0845V24.3818H49.3465Z"
        fill="currentColor"
      />
      <path
        d="M68.989 24.3818V0H87.5706C92.4678 0 94.8643 2.63963 94.8643 6.70326C94.8643 9.44708 93.6139 11.3573 91.5648 12.1214C93.8571 12.8161 95.1421 14.7263 95.1421 17.5396C95.1421 21.5685 92.6067 24.3818 87.4664 24.3818H68.989ZM75.3102 18.79H86.6675C88.1958 18.79 88.7862 18.0259 88.7862 16.7755C88.7862 15.5599 88.1958 14.7958 86.6675 14.7958H75.3102V18.79ZM75.3102 9.55128H86.4244C87.9526 9.55128 88.5431 8.78718 88.5431 7.57156C88.5431 6.32121 87.9526 5.59184 86.4244 5.59184H75.3102V9.55128Z"
        fill="currentColor"
      />
      <path
        d="M109.955 24.3818C102.383 24.3818 97.4515 19.9361 97.4515 12.1214C97.4515 4.30676 102.383 0 109.955 0H113.984C121.59 0 126.487 4.30676 126.487 12.1562C126.487 19.9709 121.59 24.3818 113.984 24.3818H109.955ZM103.807 12.1909C103.807 16.2198 106.135 18.3385 110.094 18.3385H113.88C117.839 18.3385 120.131 16.2198 120.131 12.1909C120.131 8.12727 117.839 6.04336 113.88 6.04336H110.094C106.135 6.04336 103.807 8.12727 103.807 12.1909Z"
        fill="currentColor"
      />
      <path
        d="M137.363 24.3818V5.93916H127.361V0H154V5.93916H144.101V24.3818H137.363Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Email = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM20 7.238L12.072 14.338L4 7.216V19H20V7.238ZM4.511 5L12.061 11.662L19.502 5H4.511Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const Delete = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.83329 3.33329V1.66663H14.1666V3.33329H18.3333V4.99996H16.6666V17.5C16.6666 17.721 16.5788 17.9329 16.4225 18.0892C16.2663 18.2455 16.0543 18.3333 15.8333 18.3333H4.16663C3.94561 18.3333 3.73365 18.2455 3.57737 18.0892C3.42109 17.9329 3.33329 17.721 3.33329 17.5V4.99996H1.66663V3.33329H5.83329ZM4.99996 4.99996V16.6666H15V4.99996H4.99996ZM7.49996 7.49996H9.16663V14.1666H7.49996V7.49996ZM10.8333 7.49996H12.5V14.1666H10.8333V7.49996Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const Edit = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M5.345 13.3332L13.7967 4.88157L12.6183 3.70324L4.16667 12.1549V13.3332H5.345ZM6.03583 14.9999H2.5V11.4641L12.0292 1.93491C12.1854 1.77868 12.3974 1.69092 12.6183 1.69092C12.8393 1.69092 13.0512 1.77868 13.2075 1.93491L15.565 4.29241C15.7212 4.44868 15.809 4.6606 15.809 4.88157C15.809 5.10254 15.7212 5.31447 15.565 5.47074L6.03583 14.9999ZM2.5 16.6666H17.5V18.3332H2.5V16.6666Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ShareFeedback = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM4 18.385L5.763 17H20V5H4V18.385ZM11 13H13V15H11V13ZM11 7H13V12H11V7Z"
        fill="currentColor"
      />
    </svg>
  );
};
